import React from 'react';
import styled from 'styled-components';

import { Button, TextButton } from 'components/core';
import useTranslation from 'hooks/use-translation';
import { Typography } from 'src/typography';

export type VerifiedPhoneChangeModalProps = {
  onClose: (value: { confirmed: boolean }) => void;
};

export function VerifiedPhoneChangeModal({ onClose }: VerifiedPhoneChangeModalProps): JSX.Element {
  const { t } = useTranslation();

  const handleCancel = (): void => {
    onClose({ confirmed: false });
  };

  const handleConfirm = (): void => {
    onClose({ confirmed: true });
  };

  return (
    <>
      <Typography.Heading tag='h2' size='medium' data-testid='verified-phone-change-title'>
        {t('account.changeVerifiedPhone.modalTitle', 'Are you sure?')}
      </Typography.Heading>
      <ContentContainer>
        <Typography.Body size='medium'>
          {t(
            'account.changeVerifiedPhone.modalBody',
            'Changing your phone number will remove its verified status. You may lose access to features that require a verified phone number until your new number is verified.'
          )}
        </Typography.Body>
      </ContentContainer>
      <ButtonContainer>
        <Button variant='primary' onClick={handleCancel} data-testid='verified-phone-change-cancel'>
          {t('common.cancel', 'Cancel')}
        </Button>
        <TextButton onClick={handleConfirm} data-testid='verified-phone-change-confirm'>
          {t('account.changeVerifiedPhone.confirm', 'Change phone number')}
        </TextButton>
      </ButtonContainer>
    </>
  );
}

const ContentContainer = styled.div`
  margin: 16px 0 24px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  gap: 16px;
  padding: 0 20px;

  > button {
    display: block;
  }
`;
